import React from 'react'
import Aboutbg from "../../images/about-bg.png";
import { useLanguage } from '../../Providers/LanguageContext';

export default function Nosotros3() {
  const {language}=useLanguage();
  return (

    <>

      <section id='conversation' style={{
        background: 'linear-gradient(rgba(15, 36, 55, 0.82), rgb(255, 255, 255))',
      }}>
        <div className='container-fluid'>
          <div className='mission'>
            <div>
              <div className='convo-left'>
                <div className='left-heading'>
                  {/* <h2>	</h2> */}
                  <h2 style={{
                    color:'#fff'
                  }}>{language.mission}</h2>
                </div>
                <div  className='left-content'>
                  <p style={{
                  background:'#fff'
                }}>{language.assist_people}</p>
                </div>
              </div>
            </div>
          </div>
          <div className='vission'>
          <div>
            <div className='convo-left'>
              <div className='left-heading'>
                {/* <h2>	</h2> */}
                <h2 style={{
                  color:'#fff'
                }}>{language.vision}</h2>
              </div>
              <div className='left-content'>
                <p style={{
                  background:'#fff'
                }}>{language.become_world}</p>
              </div>
            </div>
            </div>
          </div>
        </div>

        {/* <div className='convo-bg' style={{ backgroundImage: `url('${Aboutbg}')` }}></div> */}
      </section>

    </>

  )
}
